<template>
  <div>
    Когда клиенты немного достали
    <br>
    <iframe width="760" height="456" src="https://www.youtube.com/embed/16xGceArnz8" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
  </div>
</template>

<script>

export default {

}

</script>
<style>

</style>
